/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VideoOrchestratorWebhookPayload { 
    video_id: string;
    state: VideoOrchestratorWebhookPayload.StateEnum;
    machine_id?: string | null;
    timestamp: string;
    queue_position?: number | null;
    queue_type?: VideoOrchestratorWebhookPayload.QueueTypeEnum | null;
    global_queue_position?: number | null;
    priority?: number | null;
    reprocess?: boolean | null;
}
export namespace VideoOrchestratorWebhookPayload {
    export const StateEnum = {
        Pending: 'PENDING',
        Processing: 'PROCESSING',
        Completed: 'COMPLETED',
        Error: 'ERROR',
        Cancelled: 'CANCELLED'
    } as const;
    export type StateEnum = typeof StateEnum[keyof typeof StateEnum];
    export const QueueTypeEnum = {
        Priority: 'priority',
        Normal: 'normal'
    } as const;
    export type QueueTypeEnum = typeof QueueTypeEnum[keyof typeof QueueTypeEnum];
}


